// 印尼语
export default {
    login: {
        t01: 'Bahasa',
        t02: 'Netflix',
        t03: 'Silakan masukkan nama pengguna Anda',
        t04: 'Silakan masukkan kata sandi Anda',
        t05: 'Masuk',
        t06: 'Daftar',
        t07: 'Silakan masukkan nomor telepon Anda',
        t08: 'Konfirmasi kata sandi',
        t09: 'Silakan masukkan kode undangan',
        t10: 'Buat Akun',
        t11: 'Konfirmasi kata sandi Anda',
        t13: 'Kecintaan terhadap film dapat membuatmu mengumpulkan kekayaan yang melimpah tanpa disadari.',
        t14: 'Masuk Berhasil',
        t15: 'Kata sandi tidak cocok',
        t16: 'Pendaftaran Berhasil',
        t17: 'Galat jaringan',
        t18: 'Permintaan timeout, silakan periksa koneksi internet Anda'
    },
    cover_info: {
        t01: 'Mulai Menghasilkan',
        t02: 'Isi Uang',
        t03: 'Ambil Uang',
        t04: 'Sertifikat'
    },
    cont: {
        t01: 'Pilih Bahasa',
        t02: 'Semua',
        t03: 'Menunggu',
        t04: 'Selesai',
        t05: 'Dibeku',
        t06: 'Saldo Saya',
        t07: 'Belum Selesai',
        t08: 'Total Pesanan',
        t09: 'Komisi',
        t10: 'Komisi Diperoleh',
        t11: 'Jumlah Pesanan',
        t12: 'Saldo Tersedia',
        t13: 'Mulai Mengambil Pesanan',
        t14: 'Dana Akun',
        t15: 'Kirim Pesanan',
        t16: 'Kirim Semua Pesanan',
        t17: 'Waktu Pengambilan Pesanan',
        t18: 'Nomor Pesanan',
        t19: 'Total Nilai Pesanan',
        t21: 'Karya',
        t22: 'Aktor',
        t23: 'Komentar karya',
        t24: 'Batalkan',
        t25: 'Pilih Penilaian',
        t26: 'Pengiriman Pesanan Selesai',
        t27: 'Pesanan Diterima',
        t28: 'Pengambilan Pesanan Berhasil',
        t29: 'Pengambilan Pesanan Gagal, Coba Lagi!'
    }
    ,
    user: {
        t1: 'Kode Peningkat',
        t2: 'Saldo Saya',
        t3: 'Saldo Tersedia',
        t4: 'Total Pendapatan',
        t5: 'Tarik Uang Digital',
        t6: 'Catat Nama',
        t7: 'Riwayat Penarikan',
        t8: 'Detail Akun',
        t9: 'Pesan',
        t10: 'Tautkan Bank Kartu',
        t11: 'Ubah Kata Sandi',
        t12: 'Ubah Kata Sandi Penarikan',
        t13: 'Undang Teman',
        t14: 'Pilih Bahasa',
        t15: 'Keluar',
        t16: 'Tarik Uang',
        t17: 'Jumlah Tarik Tunai',
        t18: 'Nama Akun',
        t19: 'No. Telepon',
        t20: 'Jumlah Penarikan',
        t21: 'Tarik Uang',
        t22: 'Silakan masukkan jumlah penarikan',
        t23: 'Masukkan kata sandi uang virtual',
        t24: 'Total Setoran',
        t25: 'Pesan Sistem',
        t26: 'Informasi kartu bank Anda',
        t27: 'Daftar Bank',
        t28: 'Nama Bank',
        t29: 'Nama Keluarga',
        t30: 'No. Kartu Bank',
        t31: 'No. Telepon',
        t32: 'Setuju Perubahan',
        t33: 'Silakan masukkan nomor akun dan nomor IFSC dari kartu bank yang telah dihubungkan, juga mohon isi nama dan nomor telepon secara benar, jika tidak, uang setoran tidak akan sampai.',
        t34: 'Kata Sandi Lama',
        t35: 'Kata Sandi Baru',
        t36: 'Konfirmasi Kata Sandi',
        t37: 'Lanjutkan',
        t38: 'Silakan ingat kata sandi Anda, jika lupa kata sandi silakan hubungi layanan pelanggan.',
        t39: 'Salin Link Undangan',
        t40: 'Undang teman untuk mendapatkan komisi',
        t41: 'Setoran',
        t42: 'Setuju',
        t43: 'Batal',
        t44: 'Apakah Anda yakin ingin keluar?',
        t45: 'Jumlah Setoran',
        t46: 'Setoran Berhasil',
        t47: 'Diverifikasi',
        t48: 'Menunggu Verifikasi',
        t49: 'Total Penarikan',
        t50: 'Silakan atur kata sandi penarikan terlebih dahulu',
        t51: 'Silakan masukkan kata sandi lama',
        t52: 'Silakan masukkan kata sandi baru',
        t53: 'Silakan masukkan konfirmasi kata sandi',
        t54: 'Kata sandi dua kali tidak cocok',
        t55: 'Tersalin',
        t56: 'Jumlah penarikan tidak boleh kurang dari 30',
        t57: 'Berhasil dikirim, sedang memindahkan',
        t58: 'Peninjauan gagal',
        t59: 'Atur Avatar',
        t60: 'Atur Sekarang',
        t61: 'Pengaturan Berhasil',
        t62: 'Setelah pengajuan dompet disetujui, Anda perlu login untuk menarik uang',
        t63: 'Tarik tunai ke rekening bank',
        t64: 'Tarik tunai ke USDT (rasio 1:0.013)',
        t65: 'Nomor Rekening Bank',
        t66: 'Masukkan nomor rekening bank dan kode IFSC untuk kartu bank yang ingin Anda ikat, serta nama lengkap dan nomor telepon seluler Anda. Pastikan semua informasi tepat untuk memudahkan transaksi pembayaran.',
        t67: 'Silakan ikat kartu bank terlebih dahulu',
        t68: 'Pengguna mengisi ulang',
        t69: 'Pengguna menerima pesanan',
        t70: 'Komisi bawahan',
        t71: 'Pengguna menarik dana',
        t72: 'Transfer ke Yebao',
        t73: 'Transfer keluar dari Yebao',
        t74: 'Pendapatan Yebao',
        t75: 'Komisi menerima pesanan',
        t76: 'Saldo kurang dari 30, tidak dapat melanjutkan transaksi, harap hubungi layanan pelanggan',
        t77: "Silakan masukkan nama bank",
        t78: "Silakan masukkan nomor rekening bank",
        t80: "Silakan masukkan nama lengkap",
        t81: "Silakan masukkan nomor kontak",
        t82: 'Silakan masukkan jumlah pengisian',
        t83: 'Sao chép',
        t84: '100 Teratas Harian: Global',
        t85: 'Mendengarkan',
        t86: "Email",
        t87: "Silakan masukkan email Anda",
        "t88": "Kode Bank",
        "t89": "Silakan masukkan kode bank",
        t90: 'Transfer Bank',
        t91: '1. Tidak ada biaya untuk penarikan',
        t92: '2. Penarikan akan berhasil diterima dalam 10–15 menit setelah penarikan. Untuk penarikan di luar jam kerja, dana akan diterima pada jam kerja berikutnya.'
    },
    movie: {
        t01: 'Film dan acara TV populer',
        t02: 'Kata sandi dana',
        t03: 'Selisih pesanan',
        t04: 'Manajemen alamat on-chain',
        t05: 'Silakan masukkan',
        t06: 'Silakan masukkan alamat on-chain yang benar dan jaringan yang sesuai (misalnya ERC20/TRC20/BTC); jika tidak, pembayaran/transfer mungkin tidak sampai atau dapat menyebabkan kehilangan aset.',
        t07: 'Tarik ke alamat on-chain',
        t08: 'Silakan tambah',
        t09: 'Silakan tambahkan alamat on-chain',
    },
    langType: '印尼语'
}
